<template>
  <f7-list-item style="padding-left: 30px; flex: 1; margin-right: -16px;">
    <f7-label>優惠折扣(%)</f7-label>
    <f7-input type="text" placeholder="請輸入折扣" @input="updateDiscount($event.target.value)" :value="newDiscount" clear-button />
  </f7-list-item>
</template>

<script>
export default {
  data () {
    return {
      newDiscount: this.discount
    }
  },
  methods: {
    updateDiscount (discount) {
      if (discount === isNaN(parseFloat(discount))) {
        this.newDiscount = 0
      } else if (discount.trim() === '') {
        this.newDiscount = 0
      } else {
        this.newDiscount = parseFloat(discount)
      }
      this.$emit('onDiscountPropertiesChanged', this.paymentMethod, this.newDiscount)
    }
  },
  watch: {
    discount () {
      this.newDiscount = this.discount
    }
  },
  props: {
    discount: {
      type: Number
    },
    paymentMethod: {
      type: String,
      default: ''
    }
  }
}
</script>
